export default "__VITE_ASSET__BEajO0nM__"